import { Flex, Text, Card, Image, Progress, Avatar } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { TActiveEnrollment, TPreviousEnrollment } from "../../types/Aula";

const useStyles = createStyles((theme) => ({
  card: {
    cursor: "pointer",
    transition:
      "border-color 0.2s ease, box-shadow 0.2s ease, border-width 0.1s ease",
    "&:hover": {
      borderColor: theme.colors.red[5],
      boxShadow: theme.shadows.md,
      borderWidth: 2,
    },
  },
}));

export const EnrollmentCard = ({
  enrollment,
  category,
}: {
  enrollment: TActiveEnrollment | TPreviousEnrollment;
  category: "active" | "previous";
}) => {
  const minShownPercentage = 7;
  const { classes } = useStyles();

  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      component="a"
      href={`/aula-virtual/${enrollment.id}/`}
      className={classes.card}
    >
      <Card.Section>
        <Image
          src={enrollment.course.cover_image}
          alt={enrollment.course.name}
          height={160}
        />
      </Card.Section>
      <Text fw={600} size="lg" mt="md" truncate="end">
        {enrollment.course.name}
      </Text>
      <Progress.Root size={20} radius="md" mt="sm">
        <Progress.Section
          value={
            enrollment.percentage_completed < minShownPercentage
              ? minShownPercentage
              : enrollment.percentage_completed
          }
          color={
            category === "active"
              ? "blue"
              : enrollment.percentage_completed === 100
              ? "blue"
              : "red"
          }
        >
          <Progress.Label>
            {enrollment.percentage_completed || 0}%
          </Progress.Label>
        </Progress.Section>
      </Progress.Root>
      <Flex justify="space-between" align="center" mt="md">
        <Flex align="center" gap="sm">
          <Avatar
            src={enrollment.course.author.profile_image}
            alt={enrollment.course.author.name}
            h={30}
            radius="xl"
          />
          <Text size="sm" c="dimmed">
            Docente: {enrollment.course.author.name}
          </Text>
        </Flex>
        <Flex direction="column" align="flex-end">
          <Text size="sm" c="dimmed">
            {category === "active" ? "Fecha Límite:" : "Fecha de Finalización:"}
          </Text>
          <Text size="sm" c="dimmed">
            {category === "active" && "end_date" in enrollment
              ? enrollment.end_date
              : category === "previous" && "completed_at" in enrollment
              ? enrollment.completed_at || "No completado"
              : "-"}{" "}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};
